import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import LanguageIcon from '@material-ui/icons/Language';
import MainComp from './main'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import {Redirect} from 'react-router-dom'
import PrintIcon from '@material-ui/icons/Print';
import './style.css'
const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    width:'100%'
  },
}));

function ResponsiveDrawer(props) {
  //const { window } = props;

  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
const [logout,setLogout]=React.useState(false)
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
const dologout=()=>{
  localStorage.removeItem("aptitude_test_token");
  setLogout(true)
}
  const drawer = (
   <div  style={{padding:5}}>

      <center>
        <img style={{width:108,height:60}} src="https://www.reliablekota.com/images/logo.png"/>
</center>
      <Divider />

      <Divider />
      <List>

    {/*  <ListItem button onClick={()=>window.print()} >
        <ListItemIcon>{ <PrintIcon />}</ListItemIcon>
        <ListItemText  primary={"Print Result"} />
      </ListItem>
*/}
          <ListItem button component="a"  href="https://www.reliablekota.com" target="_blank">
            <ListItemIcon>{ <LanguageIcon />}</ListItemIcon>
            <ListItemText  primary={"ReliableKota.com"} />
          </ListItem>
          <ListItem button  onClick={dologout}>
            <ListItemIcon>{ <PowerSettingsNewIcon />}</ListItemIcon>
            <ListItemText  primary={"Logout"} />
          </ListItem>
      </List>
      <Divider />

    </div>
  );

  const container = props.window !== undefined ? () => props.window().document.body : undefined;

  return (
    <div className={classes.root}>

      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                     Reliable Aptitude Test Result
                   </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />

        <MainComp/>
      {logout && <Redirect to="/aptitude-test-result/login/"/>}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
